module.exports = __webpack_public_path__ + "img/3.8d0477d5.png";